export default __webpack_public_path__ + "assets/payment-icons/visa.cf8b7fe4ebe0b06d53d5164b046973cb.svg";